
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexOD9t3F2bSJMeta } from "/opt/atlassian/pipelines/agent/build/pages/index.vue?macro=true";
import { default as communicationQlrXpUUYuhMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/communication.vue?macro=true";
import { default as editfw7LvnZozlMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/edit.vue?macro=true";
import { default as indexMyUOJMAwXCMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/index.vue?macro=true";
import { default as index6RbWbDstOTMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/invoices/index.vue?macro=true";
import { default as _91id_93Jfe0bLnpdwMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/orders/[id].vue?macro=true";
import { default as indextmUcPdd9rKMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/orders/index.vue?macro=true";
import { default as pay_45on_45invoicej4wHmPXCDUMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/pay-on-invoice.vue?macro=true";
import { default as accountwAViA1ItYGMeta } from "/opt/atlassian/pipelines/agent/build/pages/account.vue?macro=true";
import { default as indexqJXazFsVc0Meta } from "/opt/atlassian/pipelines/agent/build/pages/checkout/index.vue?macro=true";
import { default as thanksXatxgcmdZHMeta } from "/opt/atlassian/pipelines/agent/build/pages/checkout/thanks.vue?macro=true";
import { default as checkout5qXjCYF1WDMeta } from "/opt/atlassian/pipelines/agent/build/pages/checkout.vue?macro=true";
import { default as communicationeyJjHkmQVjMeta } from "/opt/atlassian/pipelines/agent/build/pages/communication.vue?macro=true";
import { default as confirm_45email_45changecchWuWTNsZMeta } from "/opt/atlassian/pipelines/agent/build/pages/confirm-email-change.vue?macro=true";
import { default as forgot_45passwordLVWvp1iivhMeta } from "/opt/atlassian/pipelines/agent/build/pages/forgot-password.vue?macro=true";
import { default as logineaOYVOrhPDMeta } from "/opt/atlassian/pipelines/agent/build/pages/login.vue?macro=true";
import { default as registerQphDd3L40XMeta } from "/opt/atlassian/pipelines/agent/build/pages/register.vue?macro=true";
import { default as resend_45verify_45emailnEiw6DBBwSMeta } from "/opt/atlassian/pipelines/agent/build/pages/resend-verify-email.vue?macro=true";
import { default as reset_45passwordHNP2zWIISjMeta } from "/opt/atlassian/pipelines/agent/build/pages/reset-password.vue?macro=true";
import { default as _91_46_46_46page_93LQOgOGwcEDMeta } from "/opt/atlassian/pipelines/agent/build/pages/reviews/[...page].vue?macro=true";
import { default as reviews1OzbITw0auMeta } from "/opt/atlassian/pipelines/agent/build/pages/reviews.vue?macro=true";
import { default as indexDyhZ0ztkKBMeta } from "/opt/atlassian/pipelines/agent/build/pages/shop/index.vue?macro=true";
import { default as pickupMiK3F000SNMeta } from "/opt/atlassian/pipelines/agent/build/pages/shop/pickup.vue?macro=true";
import { default as shopypetHlg2TIMeta } from "/opt/atlassian/pipelines/agent/build/pages/shop.vue?macro=true";
import { default as terms_45and_45conditionsx0Uq77uAJOMeta } from "/opt/atlassian/pipelines/agent/build/pages/terms-and-conditions.vue?macro=true";
import { default as verify_45emailt5kjzhhOjoMeta } from "/opt/atlassian/pipelines/agent/build/pages/verify-email.vue?macro=true";
import { default as component_45stubdG7Bh3jAbPMeta } from "/opt/atlassian/pipelines/agent/build/node_modules/.pnpm/nuxt@3.15.1_@types+node@20.13.0_eslint@9.31.0_rollup@4.40.0_sass@1.77.8_stylelint@16.19.0_typ_bpeimtsjf3qzk6byulr4uuumaa/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubdG7Bh3jAbP } from "/opt/atlassian/pipelines/agent/build/node_modules/.pnpm/nuxt@3.15.1_@types+node@20.13.0_eslint@9.31.0_rollup@4.40.0_sass@1.77.8_stylelint@16.19.0_typ_bpeimtsjf3qzk6byulr4uuumaa/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue")
  },
  {
    name: accountwAViA1ItYGMeta?.name,
    path: "/en/account",
    meta: accountwAViA1ItYGMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account.vue"),
    children: [
  {
    name: "account-communication___en",
    path: "communication",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/communication.vue")
  },
  {
    name: "account-edit___en",
    path: "edit",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/edit.vue")
  },
  {
    name: "account___en",
    path: "",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/index.vue")
  },
  {
    name: "account-invoices___en",
    path: "invoices",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/invoices/index.vue")
  },
  {
    name: "account-orders-id___en",
    path: "orders/:id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders___en",
    path: "orders",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/orders/index.vue")
  },
  {
    name: "account-pay-on-invoice___en",
    path: "pay-on-invoice",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/pay-on-invoice.vue")
  }
]
  },
  {
    name: accountwAViA1ItYGMeta?.name,
    path: "/fr/account",
    meta: accountwAViA1ItYGMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account.vue"),
    children: [
  {
    name: "account-communication___fr",
    path: "communication",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/communication.vue")
  },
  {
    name: "account-edit___fr",
    path: "edit",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/edit.vue")
  },
  {
    name: "account___fr",
    path: "",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/index.vue")
  },
  {
    name: "account-invoices___fr",
    path: "invoices",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/invoices/index.vue")
  },
  {
    name: "account-orders-id___fr",
    path: "orders/:id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders___fr",
    path: "orders",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/orders/index.vue")
  },
  {
    name: "account-pay-on-invoice___fr",
    path: "pay-on-invoice",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/pay-on-invoice.vue")
  }
]
  },
  {
    name: accountwAViA1ItYGMeta?.name,
    path: "/nl/account",
    meta: accountwAViA1ItYGMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account.vue"),
    children: [
  {
    name: "account-communication___nl",
    path: "communication",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/communication.vue")
  },
  {
    name: "account-edit___nl",
    path: "edit",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/edit.vue")
  },
  {
    name: "account___nl",
    path: "",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/index.vue")
  },
  {
    name: "account-invoices___nl",
    path: "invoices",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/invoices/index.vue")
  },
  {
    name: "account-orders-id___nl",
    path: "orders/:id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders___nl",
    path: "orders",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/orders/index.vue")
  },
  {
    name: "account-pay-on-invoice___nl",
    path: "pay-on-invoice",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/pay-on-invoice.vue")
  }
]
  },
  {
    name: accountwAViA1ItYGMeta?.name,
    path: "/de/account",
    meta: accountwAViA1ItYGMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account.vue"),
    children: [
  {
    name: "account-communication___de",
    path: "communication",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/communication.vue")
  },
  {
    name: "account-edit___de",
    path: "edit",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/edit.vue")
  },
  {
    name: "account___de",
    path: "",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/index.vue")
  },
  {
    name: "account-invoices___de",
    path: "invoices",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/invoices/index.vue")
  },
  {
    name: "account-orders-id___de",
    path: "orders/:id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders___de",
    path: "orders",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/orders/index.vue")
  },
  {
    name: "account-pay-on-invoice___de",
    path: "pay-on-invoice",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/pay-on-invoice.vue")
  }
]
  },
  {
    name: accountwAViA1ItYGMeta?.name,
    path: "/it/account",
    meta: accountwAViA1ItYGMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account.vue"),
    children: [
  {
    name: "account-communication___it",
    path: "communication",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/communication.vue")
  },
  {
    name: "account-edit___it",
    path: "edit",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/edit.vue")
  },
  {
    name: "account___it",
    path: "",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/index.vue")
  },
  {
    name: "account-invoices___it",
    path: "invoices",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/invoices/index.vue")
  },
  {
    name: "account-orders-id___it",
    path: "orders/:id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders___it",
    path: "orders",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/orders/index.vue")
  },
  {
    name: "account-pay-on-invoice___it",
    path: "pay-on-invoice",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/pay-on-invoice.vue")
  }
]
  },
  {
    name: checkout5qXjCYF1WDMeta?.name,
    path: "/en/checkout",
    meta: checkout5qXjCYF1WDMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout.vue"),
    children: [
  {
    name: "checkout___en",
    path: "",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/index.vue")
  },
  {
    name: "checkout-thanks___en",
    path: "thanks",
    meta: thanksXatxgcmdZHMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/thanks.vue")
  }
]
  },
  {
    name: checkout5qXjCYF1WDMeta?.name,
    path: "/fr/checkout",
    meta: checkout5qXjCYF1WDMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout.vue"),
    children: [
  {
    name: "checkout___fr",
    path: "",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/index.vue")
  },
  {
    name: "checkout-thanks___fr",
    path: "thanks",
    meta: thanksXatxgcmdZHMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/thanks.vue")
  }
]
  },
  {
    name: checkout5qXjCYF1WDMeta?.name,
    path: "/nl/checkout",
    meta: checkout5qXjCYF1WDMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout.vue"),
    children: [
  {
    name: "checkout___nl",
    path: "",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/index.vue")
  },
  {
    name: "checkout-thanks___nl",
    path: "thanks",
    meta: thanksXatxgcmdZHMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/thanks.vue")
  }
]
  },
  {
    name: checkout5qXjCYF1WDMeta?.name,
    path: "/de/checkout",
    meta: checkout5qXjCYF1WDMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout.vue"),
    children: [
  {
    name: "checkout___de",
    path: "",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/index.vue")
  },
  {
    name: "checkout-thanks___de",
    path: "thanks",
    meta: thanksXatxgcmdZHMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/thanks.vue")
  }
]
  },
  {
    name: checkout5qXjCYF1WDMeta?.name,
    path: "/it/checkout",
    meta: checkout5qXjCYF1WDMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout.vue"),
    children: [
  {
    name: "checkout___it",
    path: "",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/index.vue")
  },
  {
    name: "checkout-thanks___it",
    path: "thanks",
    meta: thanksXatxgcmdZHMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/checkout/thanks.vue")
  }
]
  },
  {
    name: "communication___en",
    path: "/en/communication",
    meta: communicationeyJjHkmQVjMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/communication.vue")
  },
  {
    name: "communication___fr",
    path: "/fr/communication",
    meta: communicationeyJjHkmQVjMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/communication.vue")
  },
  {
    name: "communication___nl",
    path: "/nl/communication",
    meta: communicationeyJjHkmQVjMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/communication.vue")
  },
  {
    name: "communication___de",
    path: "/de/communication",
    meta: communicationeyJjHkmQVjMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/communication.vue")
  },
  {
    name: "communication___it",
    path: "/it/communication",
    meta: communicationeyJjHkmQVjMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/communication.vue")
  },
  {
    name: "confirm-email-change___en",
    path: "/en/confirm-email-change",
    meta: confirm_45email_45changecchWuWTNsZMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/confirm-email-change.vue")
  },
  {
    name: "confirm-email-change___fr",
    path: "/fr/confirm-email-change",
    meta: confirm_45email_45changecchWuWTNsZMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/confirm-email-change.vue")
  },
  {
    name: "confirm-email-change___nl",
    path: "/nl/confirm-email-change",
    meta: confirm_45email_45changecchWuWTNsZMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/confirm-email-change.vue")
  },
  {
    name: "confirm-email-change___de",
    path: "/de/confirm-email-change",
    meta: confirm_45email_45changecchWuWTNsZMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/confirm-email-change.vue")
  },
  {
    name: "confirm-email-change___it",
    path: "/it/confirm-email-change",
    meta: confirm_45email_45changecchWuWTNsZMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/confirm-email-change.vue")
  },
  {
    name: "forgot-password___en",
    path: "/en/forgot-password",
    meta: forgot_45passwordLVWvp1iivhMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___fr",
    path: "/fr/forgot-password",
    meta: forgot_45passwordLVWvp1iivhMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___nl",
    path: "/nl/forgot-password",
    meta: forgot_45passwordLVWvp1iivhMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___de",
    path: "/de/forgot-password",
    meta: forgot_45passwordLVWvp1iivhMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___it",
    path: "/it/forgot-password",
    meta: forgot_45passwordLVWvp1iivhMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/forgot-password.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: logineaOYVOrhPDMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/login.vue")
  },
  {
    name: "login___fr",
    path: "/fr/login",
    meta: logineaOYVOrhPDMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/login.vue")
  },
  {
    name: "login___nl",
    path: "/nl/login",
    meta: logineaOYVOrhPDMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/login.vue")
  },
  {
    name: "login___de",
    path: "/de/login",
    meta: logineaOYVOrhPDMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/login.vue")
  },
  {
    name: "login___it",
    path: "/it/login",
    meta: logineaOYVOrhPDMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/login.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    meta: registerQphDd3L40XMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/register.vue")
  },
  {
    name: "register___fr",
    path: "/fr/register",
    meta: registerQphDd3L40XMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/register.vue")
  },
  {
    name: "register___nl",
    path: "/nl/register",
    meta: registerQphDd3L40XMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/register.vue")
  },
  {
    name: "register___de",
    path: "/de/register",
    meta: registerQphDd3L40XMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/register.vue")
  },
  {
    name: "register___it",
    path: "/it/register",
    meta: registerQphDd3L40XMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/register.vue")
  },
  {
    name: "resend-verify-email___en",
    path: "/en/resend-verify-email",
    meta: resend_45verify_45emailnEiw6DBBwSMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/resend-verify-email.vue")
  },
  {
    name: "resend-verify-email___fr",
    path: "/fr/resend-verify-email",
    meta: resend_45verify_45emailnEiw6DBBwSMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/resend-verify-email.vue")
  },
  {
    name: "resend-verify-email___nl",
    path: "/nl/resend-verify-email",
    meta: resend_45verify_45emailnEiw6DBBwSMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/resend-verify-email.vue")
  },
  {
    name: "resend-verify-email___de",
    path: "/de/resend-verify-email",
    meta: resend_45verify_45emailnEiw6DBBwSMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/resend-verify-email.vue")
  },
  {
    name: "resend-verify-email___it",
    path: "/it/resend-verify-email",
    meta: resend_45verify_45emailnEiw6DBBwSMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/resend-verify-email.vue")
  },
  {
    name: "reset-password___en",
    path: "/en/reset-password",
    meta: reset_45passwordHNP2zWIISjMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/reset-password.vue")
  },
  {
    name: "reset-password___fr",
    path: "/fr/reset-password",
    meta: reset_45passwordHNP2zWIISjMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/reset-password.vue")
  },
  {
    name: "reset-password___nl",
    path: "/nl/reset-password",
    meta: reset_45passwordHNP2zWIISjMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/reset-password.vue")
  },
  {
    name: "reset-password___de",
    path: "/de/reset-password",
    meta: reset_45passwordHNP2zWIISjMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/reset-password.vue")
  },
  {
    name: "reset-password___it",
    path: "/it/reset-password",
    meta: reset_45passwordHNP2zWIISjMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/reset-password.vue")
  },
  {
    name: "reviews___en",
    path: "/en/reviews",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/reviews.vue"),
    children: [
  {
    name: "reviews-page___en",
    path: ":page(.*)*",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/reviews/[...page].vue")
  }
]
  },
  {
    name: "reviews___fr",
    path: "/fr/reviews",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/reviews.vue"),
    children: [
  {
    name: "reviews-page___fr",
    path: ":page(.*)*",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/reviews/[...page].vue")
  }
]
  },
  {
    name: "reviews___nl",
    path: "/nl/reviews",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/reviews.vue"),
    children: [
  {
    name: "reviews-page___nl",
    path: ":page(.*)*",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/reviews/[...page].vue")
  }
]
  },
  {
    name: "reviews___de",
    path: "/de/reviews",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/reviews.vue"),
    children: [
  {
    name: "reviews-page___de",
    path: ":page(.*)*",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/reviews/[...page].vue")
  }
]
  },
  {
    name: "reviews___it",
    path: "/it/reviews",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/reviews.vue"),
    children: [
  {
    name: "reviews-page___it",
    path: ":page(.*)*",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/reviews/[...page].vue")
  }
]
  },
  {
    name: shopypetHlg2TIMeta?.name,
    path: "/en/shop",
    meta: shopypetHlg2TIMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/shop.vue"),
    children: [
  {
    name: "shop___en",
    path: "",
    meta: indexDyhZ0ztkKBMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/shop/index.vue")
  },
  {
    name: "shop-pickup___en",
    path: "pickup",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/shop/pickup.vue")
  }
]
  },
  {
    name: shopypetHlg2TIMeta?.name,
    path: "/fr/shop",
    meta: shopypetHlg2TIMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/shop.vue"),
    children: [
  {
    name: "shop___fr",
    path: "",
    meta: indexDyhZ0ztkKBMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/shop/index.vue")
  },
  {
    name: "shop-pickup___fr",
    path: "pickup",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/shop/pickup.vue")
  }
]
  },
  {
    name: shopypetHlg2TIMeta?.name,
    path: "/nl/shop",
    meta: shopypetHlg2TIMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/shop.vue"),
    children: [
  {
    name: "shop___nl",
    path: "",
    meta: indexDyhZ0ztkKBMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/shop/index.vue")
  },
  {
    name: "shop-pickup___nl",
    path: "pickup",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/shop/pickup.vue")
  }
]
  },
  {
    name: shopypetHlg2TIMeta?.name,
    path: "/de/shop",
    meta: shopypetHlg2TIMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/shop.vue"),
    children: [
  {
    name: "shop___de",
    path: "",
    meta: indexDyhZ0ztkKBMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/shop/index.vue")
  },
  {
    name: "shop-pickup___de",
    path: "pickup",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/shop/pickup.vue")
  }
]
  },
  {
    name: shopypetHlg2TIMeta?.name,
    path: "/it/shop",
    meta: shopypetHlg2TIMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/shop.vue"),
    children: [
  {
    name: "shop___it",
    path: "",
    meta: indexDyhZ0ztkKBMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/shop/index.vue")
  },
  {
    name: "shop-pickup___it",
    path: "pickup",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/shop/pickup.vue")
  }
]
  },
  {
    name: "terms-and-conditions___en",
    path: "/en/terms-and-conditions",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___fr",
    path: "/fr/terms-and-conditions",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___nl",
    path: "/nl/terms-and-conditions",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___de",
    path: "/de/terms-and-conditions",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___it",
    path: "/it/terms-and-conditions",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/terms-and-conditions.vue")
  },
  {
    name: "verify-email___en",
    path: "/en/verify-email",
    meta: verify_45emailt5kjzhhOjoMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/verify-email.vue")
  },
  {
    name: "verify-email___fr",
    path: "/fr/verify-email",
    meta: verify_45emailt5kjzhhOjoMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/verify-email.vue")
  },
  {
    name: "verify-email___nl",
    path: "/nl/verify-email",
    meta: verify_45emailt5kjzhhOjoMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/verify-email.vue")
  },
  {
    name: "verify-email___de",
    path: "/de/verify-email",
    meta: verify_45emailt5kjzhhOjoMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/verify-email.vue")
  },
  {
    name: "verify-email___it",
    path: "/it/verify-email",
    meta: verify_45emailt5kjzhhOjoMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/verify-email.vue")
  },
  {
    name: component_45stubdG7Bh3jAbPMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubdG7Bh3jAbP
  }
]